// THIS IS AN AUTOGENERATED FILE. DO NOT MODIFY.
import { createIcon } from './utils/createIcon';

export const JumpToEntity = createIcon(
  <path
    clipRule="evenodd"
    d="M6.4958 4.38438C6.4958 3.88732 6.09286 3.48438 5.5958 3.48438C5.09875 3.48438 4.6958 3.88732 4.6958 4.38437V20.5844C4.6958 21.0814 5.09874 21.4844 5.5958 21.4844C6.09286 21.4844 6.4958 21.0814 6.4958 20.5844L6.4958 4.38438ZM18.4 3.48438C18.8971 3.48438 19.3 3.88732 19.3 4.38438L19.3 20.5844C19.3 21.0814 18.8971 21.4844 18.4 21.4844C17.9029 21.4844 17.5 21.0814 17.5 20.5844L17.5 4.38437C17.5 3.88732 17.9029 3.48438 18.4 3.48438ZM10.3 5.3V19.7H13.7V5.3H10.3ZM8.7 3.5C8.58954 3.5 8.5 3.58954 8.5 3.7V21.3C8.5 21.4105 8.58954 21.5 8.7 21.5H15.3C15.4105 21.5 15.5 21.4105 15.5 21.3V3.7C15.5 3.58954 15.4105 3.5 15.3 3.5H8.7Z"
    fillRule="evenodd"
  />,
);
